"use client"
import { cn } from '@/utils/utils';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { FaSun, FaSpinner, FaMoon } from 'react-icons/fa6';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Berlin');

export default function TheTime({ className }: { className?: string }) {
    const [mounted, setMounted] = useState(false);
    const [time, setTime] = useState<Dayjs | null>(null);

    useEffect(() => {
        setMounted(true);
        const updateTime = () => {
            setTime(dayjs().tz('Europe/Berlin'));
        };
        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    const hour = time?.hour();
    const minute = time?.minute();
    const hasTime = mounted && time !== null;

    const isDaytime = hour !== undefined && hour > 6 && hour < 20;
    const borderColor = isDaytime ? 'border-yellow-400' : 'border-blue-400';
    const icon = isDaytime ? <FaSun className="mr-2 inline animate-pulse text-yellow-400" /> : <FaMoon className="mr-2 inline animate-pulse text-blue-400" />;

    return (
        <div className={cn(`min-w-20 justify-center text-center flex items-center gap-0.5 border ${borderColor}`, className)}>
            {!hasTime ? (
                <>
                    &nbsp;
                    <FaSpinner className="inline animate-spin" />
                    &nbsp;
                </>
            ) : (
                <>
                    {icon}
                    {String(hour).padStart(2, '0')}<span className="animate-blink">:</span>{String(minute).padStart(2, '0')}
                </>
            )}
        </div>
    );
}
